import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  link: {
    display: "flex",
    color: theme.palette.primary.dark,
    textDecoration: "none",
  },
  icon: {
    marginRight: theme.spacing(0.5),
    width: 20,
    height: 20,
  },
}));
